export default "__VITE_ASSET__Bqx3oudH__"